export var PaymentTypeEnum;
(function (PaymentTypeEnum) {
    PaymentTypeEnum["SUBSCRIPTION"] = "subscription";
    PaymentTypeEnum["MIXED"] = "mixed";
    PaymentTypeEnum["UNIQUE"] = "unique";
})(PaymentTypeEnum || (PaymentTypeEnum = {}));
